export default {
  download_list: '下载列表',
  upload_store: '上传店铺',
  reference_detail: '批次详情',
  submid: '子商户号',
  store_name: '店铺名称',
  store_address: '店铺地址',
  business_line: '业务线',
  register_no: '注册号',
  dti_sec_register_no: 'DTI/SEC 注册号',
  bank_ewallet_name: '银行／钱包名称',
  account_holder_name: '账户持有人姓名',
  bank_ewallet_no: '银行／钱包账号',
  download_qr: '下载 Qr',
  upload_store_attachments: '上传店铺附件',
  qr_stand: '二维码立牌',
  qr_stand_id: '二维码立牌ID',
  receipt: '接收',
  edit_remark: '编辑备注'
}
